import { StyledChat } from './style';

import Icon from '../icon';

const Footer = () => {
  return(
    <StyledChat>
      <a
        href="https://tawk.to/chat/57aa732c37f9b71822fc0bfc/1fjgfir8c"
        target="_blank"
        rel="noreferrer"
      >
        <Icon icon="headset" />
        Falar com um dos nossos atendentes
      </a>
    </StyledChat>
  )
}

export default Footer
